import { translate } from '@fiverr-private/i18n-react';

export const getTranslatedSubCategoryName = (subCategoryId: number): string =>
    translate(`sub_categories.sub_category_${subCategoryId}.name`);
